import { Component, OnInit, Input, OnChanges, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EventEmitter } from '@angular/core';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
Quill.register('modules/blotFormatter', BlotFormatter);
@Component({
  selector: 'core-static-text',
  templateUrl: './static-text.component.html',
  styleUrls: ['./static-text.component.scss']
})

export class StaticTextComponent implements OnInit, OnChanges {

  @Input() text;
  @Input() isEditMode;
  @Input() order;
  @Output() modeChange = new EventEmitter();

  // #region "Variable"

  blockList = [];
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'subscript',
        'superscript',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'customClasses',
        'unlink',
        'insertVideo',
        'insertHorizontalRule',
        'toggleEditorMode'
      ]
    ]
  };
  quillModules = {
    blotFormatter: {},
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean'],
    ]
  };

  constructor() { }

  ngOnInit(): void  {}

  ngOnChanges(change): void {
    if(change.isEditMode){
      this.isEditMode = change.isEditMode.currentValue;
    }
    if(change.order){
      this.order = change.order.currentValue;
    }
  }

  // changeToEditMode() - Change to edit mode when no data found.
  changeToEditMode(): void {
    this.isEditMode = !this.isEditMode;
    this.modeChange.emit(this.isEditMode);
  }
}

